import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { CssBaseline } from "@mui/material";
import { RootThemeProvider } from "./theme";

import HomeRoutes from "./routes/home";
import AdminRoutes from "./routes/admin";

export default function App() {
    return (
        <RootThemeProvider>
            <CssBaseline />

            <BrowserRouter>
                <Routes>
                    <Route path="/*" element={<HomeRoutes />} />
                    <Route path="/admin/*" element={<AdminRoutes />} />

                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </BrowserRouter>
        </RootThemeProvider>
    );
}
